import { Component, OnInit } from '@angular/core';
import { async } from '@angular/core/testing';
import { CommonService } from '../common.service';
import { Router,ActivatedRoute } from "@angular/router";
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { MustMatch } from '../helper/must-match.validator';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {
  resettoken:any = "";
  isLoading = false;
  registerForm:FormGroup;
  constructor(private ActivatedRoute: ActivatedRoute,private Router:Router, private commonService: CommonService,private formBuilder: FormBuilder) { }

 async ngOnInit() {
  this.registerForm = this.formBuilder.group({
  password: ['', Validators.required],
  confirmPassword: ['',Validators.required],
 },/*{validator: this.passwordMatchValidator}*/{validator: MustMatch('password', 'confirmPassword')
 });

 this.isLoading =true;
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.resettoken = params['token'];
      console.log(this.resettoken); // Print the parameter to the console. 
  });
  var sendtokenurl="/emailToken_validation/"+this.resettoken;
  (await this.commonService.getApi(sendtokenurl)).subscribe(
    res => {
console.log(res)
if(res.status==401){
alert("Token was expired");
this.Router.navigate(['login']);
}
if(res.status!=401){
  setTimeout((res)=>{ 
    this.isLoading =false;
  }, 500);
}

    })
    
  }
  keyDownFunctionchangepassword(event){
    if (event.keyCode === 13) {
      this.submitnewpassword()
    }
  }
  get f() { console.log(this.registerForm.controls) ;
    return this.registerForm.controls; }

  async submitnewpassword(){
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
  var changepasswordapiurl="/update_password/"+this.resettoken; 
    var passwordchange = {
      'password':$("#pwd").val(),
  };
  
  (await this.commonService.postApi(changepasswordapiurl,passwordchange)).subscribe(
    res => {
       console.log(res.data);
       this.Router.navigate(['login']);
          });
        }
  backnavigate(){
    this.Router.navigate(['login']);
  }
}


